import React, { useCallback, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import Resx from '@/components/Resx'
import { ButtonSection, Main, MainBody, MainTop, MainTopTitle, WhiteBox } from '@/components/Layout'
import { Row, Col } from 'reactstrap'
import { MessageDetailContent } from '@/components/messages/detail-content'
import { Link } from 'react-router-dom'
import LoadingIndicator from '@/components/LoadingIndicator'
import { MessageEditorContent } from '@/components/messages/editor-content'
import { actionCreators } from '@/store/Messages'
import MessageEditButtons from '@/components/messages/edit-buttons'
import { ValidationBoundary } from '@/components/validation'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { useDispatch } from '@/hooks/dispatch'

const CBI = 0
const INSTITUTION = 1

const MessageDetail = function MessageDetail (props) {
  const { isNew, isReport, backUrl } = props
  const isGranted = usePermissionChecker()
  const [updateDto, updateAttachments, getMessage] = useDispatch([actionCreators.updateDto, actionCreators.updateAttachments, actionCreators.getMessage])

  const { id } = props.match.params
  // eslint-disable-next-line
  useEffect(() => { if (!isNew) getMessage(id) }, [id])

  const { message, replyMessage, replyMessageAttachments, attachments, retrieving, messageAddOrUpdate, messageSending, currentUser } = useSelector((state) => {
    const messages = state.messages
    const user = (state.identity && state.identity.user) ? state.identity.user.profile : null
    return {
      message: messages.message,
      replyMessage: messages.replyMessage,
      replyMessageAttachments: messages.replyAttachments,
      attachments: messages.attachments,
      retrieving: messages.retrieving,
      messageAddOrUpdate: messages.messageAddOrUpdate,
      messageSending: messages.messageSending,
      currentUser: user
    }
  })

  const [canManage, canDraft] = [isGranted('CanManageMessages'), isGranted('CanCreateDrafts')]

  const { messageState, recipientType, creatorUserId } = message
  const isDraft = !messageState || messageState === 0
  const userCanEdit = useMemo(() => isNew || canManage || (canDraft && creatorUserId === parseInt(currentUser.id)),
    [canDraft, canManage, currentUser.id, isNew, creatorUserId])

  const titleText = useCallback(() => retrieving ? ''
    : (isNew ? 'Messages.CreateMessage'
      : (userCanEdit ? 'Messages.EditMessage'
        : 'Messages.Detail')),
  [isNew, retrieving, userCanEdit])

  const pathText = useCallback(() => retrieving ? ''
    : (isNew ? { text: 'Messages.NewMessage' }
      : (userCanEdit ? { text: 'Messages.EditMessage' }
        : { text: 'Messages.Detail' })),
  [isNew, retrieving, userCanEdit])

  const getReplyButton = useCallback(() => {
    if (canManage) {
      if ((isReport && recipientType === INSTITUTION) || (!isReport && recipientType === CBI)) {
        return <Link className='btn btn-primary' to={`/messages/reply/${id}`}><Resx name='Messages.Reply' /></Link>
      }
    }
    return null
  }, [canManage, id, isReport, recipientType])

  return (
    <Main path={pathText()}>
      <MainTop>
        <MainTopTitle backUrl={backUrl}>
          <Resx name={titleText()} />
        </MainTopTitle>
      </MainTop>
      <MainBody transparent>
        <Row>
          <Col>
            <ValidationBoundary>
              {retrieving || messageAddOrUpdate || messageSending
                ? <LoadingIndicator />
                : <React.Fragment>
                  {isDraft && userCanEdit
                    ? <WhiteBox>
                      <MessageEditorContent message={message}
                        attachments={attachments}
                        replyMessage={replyMessage}
                        replyMessageAttachments={replyMessageAttachments}
                        updateDto={updateDto}
                        updateAttachments={updateAttachments}
                        isReport={isReport} />
                      <MessageEditButtons message={message} isReply={false} />
                    </WhiteBox>
                    : <WhiteBox>
                      <MessageDetailContent message={message} attachments={attachments} />
                      <ButtonSection>
                        <Link className='btn btn-secondary' to={backUrl}><Resx name='Common.Back' /></Link>
                        {getReplyButton()}
                      </ButtonSection>
                    </WhiteBox>
                  }
                </React.Fragment>
              }
            </ValidationBoundary>
          </Col>
        </Row>
      </MainBody>
    </Main>
  )
}

export { MessageDetail }



// WEBPACK FOOTER //
// ./src/components/messages/detail.js